import React, { useState } from "react";
import {
  MDBCheckbox,
  MDBSideNavCollapse,
  MDBSideNavItem,
  MDBSideNavLink,
} from "mdb-react-ui-kit";

const ChamberFilter = ({
                           selectedChambers,
                           setSelectedChambers,
                           chamberCollapse,
                           setChamberCollapse,}) => {
    const [chambers] = useState([
        {
            enum: 'HOUSE',
            name: 'House Committees',
            exportValue: 'House'
        }, {
            enum: 'SENATE',
            name: 'Senate Committees',
            exportValue: 'Senate'
        }, {
            enum: 'JOINT',
            name: 'Joint Committees',
            exportValue: 'Joint'
        }
    ]);

    const handleChamberChange = (chamber) => {
        setSelectedChambers((prev) => {
            if (prev.some((selected) => selected.enum === chamber.enum)) {
                return prev.filter((selected) => selected.enum !== chamber.enum);
            } else {
                return [
                    ...prev,
                    {
                        enum: chamber.enum,
                        name: chamber.name,
                        exportValue: chamber.exportValue
                    },
                ];
            }
        });
    }

  return (
    <MDBSideNavItem>
      <MDBSideNavLink
        className="accordion-button"
        icon="angle-down"
        shouldBeExpanded={chamberCollapse}
        onClick={() => setChamberCollapse(!chamberCollapse)}
      >
        Chamber
      </MDBSideNavLink>
      <MDBSideNavCollapse open={chamberCollapse}>
        <li className="p-3">
            {chambers.map((chamber) => (
              <MDBCheckbox
                key={chamber.enum}
                label={chamber.name}
                onChange={() => handleChamberChange(chamber)}
                checked={selectedChambers.some(
                  (selected) => selected.enum === chamber.enum
                )}
              />
            ))}

        </li>
      </MDBSideNavCollapse>
    </MDBSideNavItem>
  );
};

export default ChamberFilter;
